import { render, staticRenderFns } from "./FoodUpdate.vue?vue&type=template&id=b020f30c&"
import script from "./FoodUpdate.vue?vue&type=script&lang=js&"
export * from "./FoodUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FoodUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports